import { IcommunicationObj } from './interfaces';
import {log} from "./QuerloLogger";

export default class WebSockerProvider {

  private socket: any;
  private messageCB: any;
  private url = '';
  private connID = 0;
  private messageDelimiter  = '|';

  constructor(connID: number, url: string) {
      this.connID = connID;
      this.url = url;
  }

  public connect(callback: IcommunicationObj): void {
    // log.info('connecting!', this.url);
  
    this.messageCB = callback;
  
    this.socket = new WebSocket(this.url);
  
    this.socket.onopen = (): void => {
      // log.info('onOpen');
      this.broadcast({type: 'onOpen'});
    };

    this.socket.onmessage = (event: MessageEvent): void => {

      const messages = event.data.split(this.messageDelimiter);

      if (!messages.length) {
        return;
      }

      /*** patch to support messages containing |  ***/
      if (messages.length > 2) {
        messages[1] = messages.slice(1).join(this.messageDelimiter);
      }

      /** server sends messages in this format: 46|{"r":"/127.0.0.1:39558","b":"","t":35,"v":600} */
      const decodedMessageBody = this.parseMsg(messages[1] ? messages[1] : messages[0]);

      if (!decodedMessageBody) {
        return;
      }

      this.broadcast({
        type: 'onMessage',
        msg: decodedMessageBody
      });
    };

    this.socket.onclose = (): void => {
      log.info('disconnect');
      this.broadcast({
        type: 'onClose'
      });
    };
  
    this.socket.onerror = (e: MessageEvent) => {
      log.info('error', e);
      this.broadcast({
        type: 'onError',
        msg: e
      });
    };

  }

  public unsubscribe(): void {
    this.socket.close();
  }

  private parseMsg(message: any): any {
    try {
      return JSON.parse(message);
    } catch (e) {
      //log.info('This doesn\'t look like a valid JSON: ', response);
      return false;
    }
  }
  
  private push(msg: any): void {
    this.socket.send(JSON.stringify(msg));
  }

  private broadcast(obj: any): void {
    obj.id = this.connID;
    // log.info('this.broadcasting websocket message', obj);
    this.messageCB(obj);
  }

  private onReconnect = (request: any): void => {
    log.info('CONNECTION: RECONNECTING...');

    this.broadcast({
      type: 'onReconnect',
      request
    });
  };

}
